import { useEffect } from "react";
import axios from "axios";

// Records once per browser session which outside site (or ?utm_source campaign) sent the visitor.
export const VisitTracker = () => {
  useEffect(() => {
    try {
      if (sessionStorage.getItem("rv_visit_logged")) return;
      sessionStorage.setItem("rv_visit_logged", "1");
      let referrer = document.referrer || "";
      try {
        if (referrer && new URL(referrer).host === window.location.host) referrer = "";
      } catch {
        referrer = "";
      }
      const utm_source = new URLSearchParams(window.location.search).get("utm_source") || "";
      axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/track/visit`, { referrer, utm_source, landing: window.location.pathname }).catch(() => {});
    } catch {
      /* storage blocked — skip */
    }
  }, []);
  return null;
};
